import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { Dialog, DialogContent, DialogHeader, DialogOverlay, DialogPortal, DialogTitle } from "@/components/ui/dialog"
import { ChBillingDialogContent } from "@/modules/patients/agenda/teleconsultation/appointment-action-menu/billing/ch/ch-billing-dialog-content"
import { DeBillingDialogContent } from "@/modules/patients/agenda/teleconsultation/appointment-action-menu/billing/de/de-billing-dialog-content"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"

type BillingDialogProps = {
  appointmentId: string
  onClose: () => void
  isEditable: boolean
}

export const BillingDialog = ({ appointmentId, onClose, isEditable }: BillingDialogProps) => {
  const { t } = useTranslation()
  const country = useCountryParam()

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()} />
        <DialogContent
          variant="small"
          onMouseDown={(e) => e.stopPropagation()}
          onPointerDownOutside={(e) => e.preventDefault()}
          onClick={(e) => e.stopPropagation()}
          data-testid="billing-dialog">
          <DialogHeader>
            <DialogTitle>{t("patient.agenda.billingDialog.title")}</DialogTitle>
          </DialogHeader>
          <Suspense>
            {country === "CH" ? (
              <ChBillingDialogContent
                isEditable={isEditable}
                appointmentId={appointmentId}
                onCancel={onClose}
                onSave={onClose}
              />
            ) : (
              <DeBillingDialogContent
                isEditable={isEditable}
                appointmentId={appointmentId}
                onCancel={onClose}
                onSave={onClose}
              />
            )}
          </Suspense>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}
